import React from 'react';
import get from 'lodash/get';
import classnames from 'classnames';
import {arrayOf, bool, func, object} from 'prop-types';
import setDisplayName from 'recompose/setDisplayName';
import compose from 'recompose/compose';
import {Label} from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';
import BasicModal from 'components/common/BasicModal';
import {formDataManager} from 'hoc/formDataManager';
import {basicForm} from 'utils/helpers';
import config from './createUserFormConfig';

const CreateUserForm = basicForm(config);

class CreateUserModal extends React.Component {
  static propTypes = {
    formData: object.isRequired,
    submit: func.isRequired,
    onValueChanged: func.isRequired,
    onValidationError: func,
    hasErrors: bool,
    errors: arrayOf(object),
    isInFlight: bool,
    onClose: func.isRequired,
    isOpen: bool.isRequired
  };

  state = {
    // default to valid state so we're not showing warnings prematurely.
    passwordsMatch: true
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      passwordsMatch: nextProps.formData.password === nextProps.formData.passwordConfirmation
    });
  }

  get actions() {
    return [
      {
        label: <FormattedMessage id='userManagement.createUser.cancel' />,
        action: this.props.onClose,
        displayType: 'menu-item'
      },
      {
        label: <FormattedMessage id='userManagement.createUser.submit' />,
        loading: this.props.isInFlight,
        isDisabled: !this.canSubmit,
        action: this.props.submit,
        displayType: 'button',
        primaryCheck: true
      }
    ];
  }

  touchedField = fieldName => {
    return get(this.props.formData, `${fieldName}.length`, 0) > 0;
  };

  get showPasswordWarning() {
    // make sure the user has entered values into both password fields before we bug them about a mismatch.
    const touchedBothFields = this.touchedField('password') && this.touchedField('passwordConfirmation');
    return touchedBothFields && !this.state.passwordsMatch;
  }

  get formIsComplete() {
    return config.fields.every(field => this.props.formData[field.name]);
  }

  get canSubmit() {
    return !this.props.hasErrors && this.formIsComplete && this.state.passwordsMatch;
  }

  render() {
    const {showPasswordWarning} = this;
    const formClassName = classnames('create-user-form', {'password-mismatch': showPasswordWarning});

    return (
      <BasicModal
        header={<FormattedMessage id='userManagement.createUser.title' />}
        specialType='primary-modal create-user-modal'
        actions={this.actions}
        open={this.props.isOpen}
        onClose={this.props.onClose}>
        <div className={formClassName}>
          <CreateUserForm
            onValueChanged={this.props.onValueChanged}
            onValidationError={this.props.onValidationError}
            errors={this.props.errors}
            data={this.props.formData} />
          {showPasswordWarning && (
            <Label basic className='db-error-label password-mismatch-indicator'>
              <FormattedMessage id='errors.validation.password_mismatch' />
            </Label>
          )}
        </div>
      </BasicModal>
    );
  }
}

export default compose(
  formDataManager({}, config),
  setDisplayName('CreateUserModal')
)(CreateUserModal);



// WEBPACK FOOTER //
// ./public/pages/UserManagement/CreateUserModal/CreateUserModal.jsx